import React from 'react'
import MicroModal from 'micromodal'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'

import Contact from '../Form/Contact'
import BookMeeting from '../Form/BookMeeting'

const StyledModal = styled.div`
  .modal {
    &[aria-hidden='false'] {
      .overlay {
        animation: mmfadeIn 0.5s cubic-bezier(0, 0, 0.2, 1);
      }
    }
    &[aria-hidden='false'] {
      .content-wrapper {
        animation: mmslideIn 0.5s cubic-bezier(0, 0, 0.2, 1);
      }
    }
    &[aria-hidden='true'] {
      .overlay {
        animation: mmfadeOut 0.5s cubic-bezier(0, 0, 0.2, 1);
      }
    }
    &[aria-hidden='true'] {
      .content-wrapper {
        animation: mmslideOut 0.5s cubic-bezier(0, 0, 0.2, 1);
      }
    }
  }
`

const StyledTabs = styled.div`
  .react-tabs__tab-list {
    ${tw`grid grid-cols-3 mb-10 md:mb-14 border! border-primary-700 rounded-lg overflow-hidden`}
  }
  .react-tabs__tab {
    ${tw`text-sm text-primary-700 font-semibold py-2 px-4 bg-white rounded-none flex items-center justify-center w-full border-none bottom-0 transition-colors duration-300 ease-linear`}
  }
  .react-tabs__tab--selected {
    ${tw`text-white bg-primary-700`}
    svg {
      path {
        ${tw`text-white`}
      }
    }
  }
  .react-tabs__tab-panel {
    ${tw`md:hidden`}
  }

  .react-tabs__tab-panel--selected {
    ${tw`md:block`}
  }
`

const ContactModal = () => {
  if (typeof window !== 'undefined') {
    MicroModal.init({
      openTrigger: 'data-modal-open',
      closeTrigger: 'data-modal-close',
      disableFocus: true,
      disableScroll: true,
      awaitOpenAnimation: true,
      awaitCloseAnimation: true
    })
  }

  return (
    <StyledModal>
      <div
        className='modal relative z-50 hidden'
        id='modal-contact'
        aria-hidden='false'
      >
        <div
          className='overlay fixed top-0 right-0 left-0 bottom-0 flex items-center justify-center bg-black/50 outline-none'
          tabIndex='-1'
          data-modal-close
        >
          <div
            className='content-wrapper ml-auto h-screen w-full max-w-[720px] overflow-auto bg-white'
            role='dialog'
            aria-modal='true'
          >
            <div className='flex items-center justify-between border-b border-gray-400/20 px-5 pt-12 pb-4 md:py-4'>
              <a
                href='tel:4242071383'
                className='hover:text-primary-800 flex items-center font-bold text-primary-700 no-underline'
              >
                <i className='fas fa-phone mr-1'></i>
                (424) 207-1383
              </a>
              <i
                className='close fal fa-times cursor-pointer text-xl text-black transition-all duration-300 ease-linear hover:text-primary-700'
                data-modal-close
              ></i>
            </div>

            <div className='px-4 pt-8 pb-14 md:px-18'>
              <header className='mb-6 text-center md:mb-7'>
                <p className='heading-three text-[#26272B]'>Contact Us</p>
              </header>

              <StyledTabs>
                <Tabs forceRenderTabPanel={true}>
                  <TabList>
                    <Tab>
                      <i className='fa-regular fa-calendar mr-2 text-lg'></i>
                      Book{' '}
                      <span className='ml-1 hidden md:inline'>a Meeting</span>
                    </Tab>
                    <Tab>
                      <i className='fa-regular fa-envelope mr-2 text-lg'></i>
                      Message <span className='ml-1 hidden md:inline'>Us</span>
                    </Tab>
                    <Tab>
                      <i class='fa-regular fa-headset mr-2 text-lg'></i>
                      Support
                    </Tab>
                  </TabList>

                  <TabPanel>
                    <div className='h-screen'>
                      {' '}
                      <iframe
                        title='Calendly iframe'
                        frameborder='0'
                        src='https://calendly.com/scottsillari/freetechconsult'
                        width='100%'
                        height='100%'
                      ></iframe>
                    </div>
                  </TabPanel>

                  <TabPanel>
                    <Contact />
                  </TabPanel>

                  <TabPanel>
                    <div className='h-screen'>
                      {' '}
                      <iframe
                        title='Calendly iframe'
                        frameborder='0'
                        src='https://calendly.com/realsynchsupportteam/30min'
                        width='100%'
                        height='100%'
                      ></iframe>
                    </div>
                  </TabPanel>
                </Tabs>
              </StyledTabs>
            </div>
          </div>
        </div>
      </div>
    </StyledModal>
  )
}
export default ContactModal
